.page {
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 640px;
  margin: 0 auto;
}

.title {
  font-size: 28px;
}

.sent {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.heading {
  font-size: 17px;
}

.list {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}
